import script from "./SubformDarkView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubformDarkView.vue?vue&type=script&setup=true&lang=js"

import "./SubformDarkView.vue?vue&type=style&index=0&id=ec6645c6&lang=scss"

const __exports__ = script;

export default __exports__